import React, { Component } from 'react';
import {
  map,
} from 'ramda';
import { Link } from 'react-router-dom';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import ApplicationsIcon from '@material-ui/icons/AppsOutlined';
import Button from '@material-ui/core/Button';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Panel from '../Panel';
import withStyles from '@material-ui/core/styles/withStyles';
import CreateApplicationDialogue from './CreateApplicationDialogue';
import PaginatedSearch from '../PaginatedSearch';
import { stylesToPropType } from '../../utils';

const styles = () => ({
  tableNoMargins: {
    paddingLeft: '2px',
    paddingRight: '3px',
  },
});

class ApplicationTable extends Component {
  debouncedQuery = null;

  state = {
    createApplicationDialogueOpen: false,
  };

  componentDidMount() {

  }

  renderEndpoints = (data, match) => {
    const { classes } = this.props;

    return (
      <TableBody>
        {map(
          application => (
            <TableRow key={application.fields.applicationID}>
              <TableCell className={classes.tableNoMargins}>
                <Link to={`${match.url}/${application.fields.applicationID}`}>
                  <Typography variant="subheading" color="inherit">
                    {[application.fields.domain, application.fields.childAppName]
                      .filter(o => o)
                      .join(' - ')}
                  </Typography>
                </Link>
              </TableCell>
              <TableCell colSpan="3" className={classes.tableNoMargins}>
                <Typography variant="caption" gutterBottom align="left">
                  Client ID
                </Typography>
                &nbsp;{application.fields.clientID}
              </TableCell>
              <TableCell className={classes.tableNoMargins}>
                <Link
                  to={{
                    pathname: `${match.url}/${
                      application.fields.applicationID
                    }/settings`,
                    state: { application },
                  }}
                >
                  <SettingsIcon />
                </Link>
              </TableCell>
            </TableRow>
          ),
          data,
        )}
      </TableBody>
    );
  }

  render() {
    const {
      onChangeInput,
      onClickPage,
      applications,
      searchTxt,
      currentPage,
      recordsPerPage,
      applicationCount,
      isLoading,
      selectedTeam,
      personalApplicationCount,
    } = this.props;

    const disableNewButton = (selectedTeam === "personal" && personalApplicationCount >= 5);

    return (
      <Panel
        id="applicationsPanel"
        title="Applications"
        avatar={<Avatar><ApplicationsIcon /></Avatar>}
      >
        <PaginatedSearch
          searchTxt={searchTxt}
          onChangeInput={onChangeInput}
          renderEndpoints={this.renderEndpoints}
          formPlaceholder="Search applications here"
          currentPage={currentPage}
          thresholdPageBtns={5}
          onClickPage={onClickPage}
          recordsPerPage={recordsPerPage}
          totalRecords={applicationCount}
          data={applications}
          isLoading={isLoading}
          {...this.props}
        />
        <Button
          variant="contained"
          color="primary"
          style={{
            borderRadius: '0.125em',
            margin: '0',
          }}
          onClick={() => this.setState({ createApplicationDialogueOpen: true })}
          disabled={disableNewButton}
        >
          New Application
        </Button>
        <CreateApplicationDialogue
          onClose={() => this.setState({ createApplicationDialogueOpen: false })}
          onSave={application => this.setState(
            state => ({
              createApplicationDialogueOpen: false,
            }),
            () => { this.props.refetch(); },
          )}
          applications={applications}
          open={this.state.createApplicationDialogueOpen}
          env={this.props.env}
        />
      </Panel>
    );
  }
}

ApplicationTable.propTypes = {
  classes: stylesToPropType(styles()).isRequired,
};

export default withStyles(styles)(ApplicationTable);
